export const baseUrl = "https://alwathiq-backend.devoracompany.com/api/v1";

export const governoratesURL = "/governorates";

export const areasURL = "/areas";

export const loginURL = "login";

export const productsURL = "/products";

export const exportProductSaleURL = "/export/product-sales";

export const categoriesURL = "/categories";

export const privacyPolicyURL = "/dashboard/privacy-policy";

export const discountCouponsURL = "/dashboard/discount-coupons";

export const clientsURL = "clients/";

export const trainersURL = "trainers";

export const clientURL = "/users";

export const usersURL = "users";

export const permissionsURL = "permissions";

export const notificationsURL = "notifications";

export const statisticsURL = "/statistics";

export const exportProductsURL = "/products/export";

export const exportClientsURL="/clients/export"

export const exportOrdersURL = "/products/orders";

export const ordersAgentURL = "/agent/orders";

export const departmentsURL = "departments";

export const contactUsURL = "contact-us";

export const ordersURL = "/orders";

export const agentAssURL="/agent-assignments"

export const advertisementsURL = "/advertisements";

export const storeInfoURL = "/dashboard/store-info";
